import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";

const FAQSection = () => {
  const [openItems, setOpenItems] = useState({});
  const [faqItems, setFaqItems] = useState([]);

  useEffect(() => {
    // Fetch FAQs from backend
    const fetchFAQs = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/faqs/all-faqs`);
        setFaqItems(res.data);
      } catch (err) {
        console.error("Failed to load FAQs", err);
      }
    };
    fetchFAQs();
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: false,
      offset: 100,
      delay: 0,
    });
    return () => AOS.refresh();
  }, []);

  const toggleItem = (id) => {
    setOpenItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <div className="p-4 sm:p-6 lg:p-8">
      <h2
        className="text-2xl sm:text-3xl font-bold text-gray-900 mb-6 sm:mb-8"
        data-aos="fade-right"
      >
        Frequently Asked Questions
      </h2>

      <div
        className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6"
        data-aos="zoom-out"
      >
        {faqItems.map((item) => (
          <div
            key={item.id}
            className={`border rounded-2xl p-4 sm:p-6 transition-all duration-200 hover:shadow-sm ${
              openItems[item.id]
                ? "border-orange-200 bg-orange-50"
                : "border-gray-200 bg-white"
            }`}
          >
            <div className="flex items-start justify-between gap-3">
              <div className="flex items-start gap-3 sm:gap-4 flex-1">
                <span className="text-orange-500 font-medium text-sm sm:text-base flex-shrink-0 mt-0.5">
                  {item.id}
                </span>
                <div className="flex-1">
                  <h3 className="text-gray-900 font-medium text-sm sm:text-base leading-relaxed pr-2">
                    {item.question}
                  </h3>
                  {openItems[item.id] && (
                    <p className="text-gray-600 text-xs sm:text-sm mt-3 leading-relaxed">
                      {item.answer}
                    </p>
                  )}
                </div>
              </div>

              <button
                onClick={() => toggleItem(item.id)}
                className="flex-shrink-0 w-6 h-6 sm:w-7 sm:h-7 flex items-center justify-center text-gray-400 hover:text-gray-600 transition-colors"
              >
                {openItems[item.id] ? (
                  <svg
                    className="w-4 h-4 sm:w-5 sm:h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                ) : (
                  <svg
                    className="w-4 h-4 sm:w-5 sm:h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                    />
                  </svg>
                )}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQSection;